import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Instagram, Mail, MapPin, Phone, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { useT } from "../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useT();
  return (
    <footer className="bg-[#e7f4fd] text-[#131517] mt-32" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 grid lg:grid-cols-12 gap-8 items-start">
        <div className="lg:col-span-4">
          <Logo height={42} />
          <p className="mt-4 text-sm text-[#3f444b] max-w-xs leading-relaxed">
            {t("footer.tagline")}
          </p>
        </div>

        <div className="lg:col-span-4 space-y-2.5 text-sm">
          <div className="flex items-start gap-2.5">
            <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#1093f0]" />
            <span>10 Av. du Stade de France, 93210 Saint-Denis</span>
          </div>
          <div className="flex items-center gap-2.5">
            <Mail className="w-4 h-4 shrink-0 text-[#1093f0]" />
            <a href="mailto:hello@hecnos.fr" className="hover:underline">hello@hecnos.fr</a>
          </div>
          <div className="flex items-center gap-2.5">
            <Phone className="w-4 h-4 shrink-0 text-[#1093f0]" />
            <a href="tel:+33699292171" className="hover:underline">+33 6 99 29 21 71</a>
          </div>
        </div>

        <div className="lg:col-span-2 flex lg:justify-center">
          <Link
            to="/contact?type=join"
            data-testid="footer-join-cta"
            className="hx-btn-primary inline-flex items-center gap-2 bg-[#1093f0] text-white px-5 py-2.5 rounded-full text-sm font-semibold"
          >
            {t("common.joinAdventure")}
            <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="lg:col-span-2 flex lg:justify-end items-center gap-3">
          <a
            href="https://www.linkedin.com/company/hecnos"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
            data-testid="footer-linkedin"
            className="w-10 h-10 rounded-full border border-[#1093f0]/40 flex items-center justify-center text-[#1093f0] hover:bg-[#1093f0] hover:text-white transition-colors"
          >
            <Linkedin className="w-4 h-4" />
          </a>
          <a
            href="https://www.instagram.com/hecnos_conseil/"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            data-testid="footer-instagram"
            className="w-10 h-10 rounded-full border border-[#1093f0]/40 flex items-center justify-center text-[#1093f0] hover:bg-[#1093f0] hover:text-white transition-colors"
          >
            <Instagram className="w-4 h-4" />
          </a>
        </div>
      </div>

      <div className="border-t border-[#1093f0]/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#3f444b]">
          <span>© {new Date().getFullYear()} Hecnos SAS. {t("footer.rights")}</span>
          <div className="flex items-center gap-5">
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#1093f0] hover:underline">{t("footer.privacy")}</Link>
            <Link to="/terms" data-testid="footer-terms" className="hover:text-[#1093f0] hover:underline">{t("footer.terms")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
